import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getLeaderboard } from '@powdr/stores';

export const useLeaderboard = (timeframe, stat) => {
  if (!timeframe || !stat) return null;

  const dispatch = useDispatch();
  const useLeaderboardData = useSelector((state) => state.leaderboard);
  const { data } = useLeaderboardData;
  const [leaderboardData, setLeaderboardData] = useState();

  useEffect(() => {
    dispatch(getLeaderboard());
  }, [dispatch]);

  useEffect(() => {
    if (data) {
      setLeaderboardData(data?.[stat]?.[timeframe]);
    }
  }, [data, stat, timeframe]);

  return leaderboardData;
};
